import { render, staticRenderFns } from "./ModalRequisitionDetails.vue?vue&type=template&id=4262d056&lang=pug&"
import script from "./ModalRequisitionDetails.vue?vue&type=script&lang=js&"
export * from "./ModalRequisitionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports